

































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import BaseContainer from '@/components/BaseContainer.vue';
import StatusPanelorder from '@/components/StatusPanelorder.vue';
import BaseInfoPanel from '@/components/BaseInfoPanel.vue';
import { Inquiry, Carrier, yun } from '@/http';
import ButtonPanel from '@/components/ButtonPanel.vue';
import CspDialog from '@/components/CspDialog.vue';
import orderDetailcc from './orderDetailcc.vue';
import { enums } from '@/common/enums';
import { formRules } from '@/common/util/validator';
import { default as DataPanel } from '@/components/DataPanel.vue';
import publicFunc from '../../common/util/publicFunc';
@Component({
    components: {
        BaseContainer,
        orderDetailcc,
        StatusPanelorder,
        BaseInfoPanel,
        ButtonPanel,
        CspDialog,
        DataPanel,
    },
})
export default class InquiryDetail extends Vue {
    public winVisible = false;
    public formDataWin: any = {};
    public loading: boolean = false;
    public adjustCarrierVisible = false;
    public requoteVisible = false;
    public title: string = '运价填报员在线填写本次发货计划的运价信息，该发货计划以填写的运价执行';
    public cspdiaConfig: any = {
        cspDialogVisible: false,
        title: '询价单终结',
        content: '确认终结询价单？',
    };
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public id: any = '';
    public name: any = '';
    public from: any = '';
    public auditComment:any = ''
    public fData:any = {
        id: this.$route.query.id,
        shipOrderNo: '',
        belongCarrierId: '',
        belongCarrierName: '',
        belongRemark: '',
        priceId: '',
        realPrice: '',
        pricingMode: 1,
        oilCardPercent: 0,
        paymentWay: ''
    }
    public cartables:any = []
    public detailData: any = {};
    public goodsList: any = [];
    public formDataRequote: any = {};
    public fee: any = '';
    public fhdb3: boolean = false;
    public fhdz3: boolean = false;
    public fhds3: boolean = false;
    public pricingModeType = enums.pricingModeType;
    public fhdw3: boolean = false;
    public async created() {
        let webMenus = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus;
        this.fhdb3 = webMenus.includes('fhdb3');
        this.fhdz3 = webMenus.includes('fhdz3');
        this.fhds3 = webMenus.includes('fhds3');
        this.fhdw3 = webMenus.includes('fhdw3');
        this.fee = this.$route.query.fee;
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        this.from = this.$route.query.from;
        let res = await Carrier.GetList({ count: -1 });
        this.carrierList = res.data;
        await this.reload();
    }
    async getcar() {}
    /**装车要素 */
    async getLoadType() {
        this.getLoadTypeList = await yun.GetDicList({ typeName: 'loadingEffect' });
    }
    public allCarrierBtnList: any = [];
    public allCarrierBtnListId: any = [];
    public tableList: any = [];
    public inquiryCarrierList: any = [];
    public getLoadTypeList: any = [];
    public carrierVisible: any = false;
    public sssing: any = '';
    public carrierId1 = '';
    public carrierName1 = '';
    public CarriageWay1: any = '';
    public freightUnitType = enums.freightUnitType;
    public cars: any = [];
    public async addCarrier() {
        // let goodsForm = this.goodsListvalidateForm();
        this.carrierVisible = true;
        // let res = await yun.GetCarrierByShipper(this.detailData.shipperId)
        this.$refs.fData.resetFields();
    }
    async reload() {
        this.getLoadTypeList = await yun.GetDicList({ typeName: 'loadingEffect' });
        this.tableData = [];
        this.tableList = [];
        this.inquiryCarrierList = [];
        this.isChangeCarrier = false;
        let res = await yun.OrdergetDetaill(this.id)
        console.log('resddddd', res)
        this.detailData = res;
        this.inquiryCarrierList = res.inquiryCarrierList;
        let carLengthArr = res.carLength.split(',');
        carLengthArr.forEach((item) => {
            this.tableList.push({
                carLength: item,
                price: '',
            });
        });
        if (this.detailData.inquiryQuotes && this.detailData.inquiryQuotes.length > 0) {
            this.detailData.inquiryQuotes.forEach((item) => {
                this.tableData.push({
                    carrierName: item.carrierName,
                    timesIndex: item.timesIndex,
                    quotes: item.quotes,
                    isWin: item.isWin,
                });
            });
        }

        this.getSpanArr(this.tableData);
        this.allCarrierBtnList = [];
        this.allCarrierBtnListId = [];
        this.carrierList.forEach((i) => {
            this.allCarrierBtnList.push(i.name);
            this.allCarrierBtnListId.push({
                id: i.id,
                name: i.name,
            });
        });
        this.currentBtn = [];
        console.log('getLoadTypeList', this.getLoadTypeList, res.loadingEffect);
        this.getLoadTypeList.forEach((datas) => {
            res.loadingEffect.split(',').forEach((dd) => {
                if (dd == datas.name) {
                    this.currentBtn.push(datas);
                }
            });
        });
        console.log('resd', this.detailData.inquiryCode);
    }
    public async mounted() {}
    public spanArr = [];
    public pos = 0;
    getSpanArr(data) {
        this.spanArr = [];
        for (var i = 0; i < data.length; i++) {
            if (i === 0) {
                this.spanArr.push(1);
                this.pos = 0;
            } else {
                // 判断当前元素与上一个元素是否相同  inAccessCode（批次字段）
                if (data[i].carrierName === data[i - 1].carrierName) {
                    this.spanArr[this.pos] += 1;
                    this.spanArr.push(0);
                } else {
                    this.spanArr.push(1);
                    this.pos = i;
                }
            }
        }
    }
    public goInquiry(item) {
        this.$router.push({
            path: '/AddInquiry',
            query: {
                id: item,
                type: 'order',
            },
        });
    }
    public requoteClose() {
        this.requoteVisible = false;
    }
    public freightSourceChange() {
        this.detailData.carrierId = '';
        this.detailData.carrierName = '';
        this.detailData.freightUnitType = '';
        this.detailData.freightUnitPrice = '';
        this.detailData.pricingMode = '';
        this.carrierChange();
        if (this.detailData.freightSource == 1) {
            this.detailData.carrierId = this.carrierId1;
            this.detailData.carrierName = this.carrierName1;
            this.detailData.pricingMode = 1;
        }
    }
    public sscar: any = '';
    carss(index, resd) {
        this.sscar = index;
        this.formData.carrierId = resd.carrierId;
        this.formData.carrierName = resd.carrierName;
        this.detailData.freightUnitPrice = resd.singlePrice ? resd.singlePrice : this.detailData.singlePrice;
        this.detailData.freightUnit = 1;
    }
    public sssingin(data, index) {
        this.sssing = index;
        this.detailData.freightUnitPrice = data.priceValue;
        if (this.detailData.pricingMode == 1) {
            this.detailData.freightUnit = 1;
        } else {
            this.detailData.freightUnit = 2;
        }
    }
    public async saveRequote() {
        if (this.currentBtn.length == 0) {
            this.$message.warning('请选择承运商');
        } else {
            let carrierIds = [];
            this.currentBtn.forEach((i) => {
                let res = this.allCarrierBtnListId.filter((v) => v.name == i)[0];
                carrierIds.push(res.id);
            });
            await Inquiry.BackQuote({
                inquiryId: this.id,
                carrierIds: carrierIds,
            });
            this.$message.success('定向询价承运商调整成功！');
            this.$router.push('/SingleInquiry');
        }
    }
    public $refs: {
        fData: HTMLFormElement;
        formData: HTMLFormElement;
        detailData: HTMLFormElement;
    };

    public carCodeEnd() {
        console.log('cc2');
        if (!this.fData.belongCarrierId) {
            this.fData.priceId = '';
            this.fData.realPrice = '';
            this.fData.oilCardPercent = '';
            this.fData.paymentWay = '';
        }
    }
    public carCodechange(val) {
        this.fData.belongCarrierId = '';
    }
    async querySearch1(queryString, cb) {
        let res = await yun.GetCarrierByShipper({ shipperName: this.fData.belongCarrierName, shipperId :this.detailData.shipperId,count: -1 });
        console.log(res);
        let result = [];
        res.forEach((dd) => {
            let xx = {
                value: dd.carrierName,
                carrierId: dd.carrierId,
                relationId: dd.relationId,
            };
            result.push(xx);
        });
        cb(result);
    }
    selectCar1(data) {
        this.fData.belongCarrierId = data.carrierId;
        this.fData.relationId = data.relationId;

        // if (this.fData)
        this.GetPrice();
    }
    public isChangeCarrier = false;
    public changeCarrier() {
        this.isChangeCarrier = true;
    }
    handleClose1() {
        this.detailData.freightSource = '';
        this.detailData.carrierName = '';
        this.detailData.carrierId = '';
        this.carrierVisible = false;
    }
    public formData: any = {
        id: '',
        realPrice: '',
        pricingMode: '',
        oilCardPercent: 0,
        paymentWay: ''
    };
    public dynamicTags = [];
    handleInput1(e, index) {
        e.target.value = e.target.value.match(/\d{1,9}(\.\d{0,2})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,2})?/)[0] : '';
        this.detailData.freightUnitPrice = e.target.value;
    }
    public carrierChange() {
        this.GetPrice();
    }
    public SinglePriceList: any = [];
    public payTableD:any = []
    async GetPrice() {
        let data = {
            carrierId: this.fData.belongCarrierId,
            arrivalCity: this.detailData.arrivalCity,
            arrivalArea: this.detailData.arrivalCounty,
        };
        let res = await yun.GetBasePrice(data);
        console.log('payTableD', res)
        this.payTableD = res.extData
        // this.formData.freightUnitPrice = res.extData;
    }
    selectPay(data) {
        this.fData.priceId = data.id
        this.fData.paymentWay = data.paymentWay
        this.fData.oilCardPercent = data.oilCardPercent
        this.fData.realPrice = data.unitPrice
        this.fData.pricingMode = Number(data.pricingMode)
    }
    public freightSourceList: any = [];
    public tableData: any = [];
    public colData: any = [];

    public adjustCarrierClose() {
        this.$refs.formData.resetFields();
        this.adjustCarrierVisible = false;
    }

    public oldData: any = [];
    //调整承运商
    adjustCarrier() {
        this.adjustCarrierVisible = true;
        this.oldData = JSON.parse(JSON.stringify(this.formData.carrierIds));
        this.dynamicTags = [];

        this.formData.carrierIds.forEach((item) => {
            let res = this.carrierList.filter((v) => v.id == item)[0];
            this.dynamicTags.push({
                name: res.name,
                id: res.id,
            });
        });
    }
    //一键催报
    async reminder() {
        await Inquiry.Urge(this.id);
        this.$message.warning('单笔询价催报成功！');
    }
    //承运商重新报价
    requote() {
        this.requoteVisible = true;
        let currBtnName = [];
        this.inquiryCarrierList.forEach((item) => {
            currBtnName.push(item.carrierName);
        });
        this.currentBtn = currBtnName;

        console.log('this.allCarrierBtnList' + JSON.stringify(this.allCarrierBtnList));
        console.log('  this.currentBtn' + JSON.stringify(this.currentBtn));
    }
    //一键否决
    reject() {
        this.$confirm('承运商报价全部拒绝!', '一键否决', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                Inquiry.RejectAllQuote(this.id).then(() => {
                    this.$message.success('单笔询价招标失败！');
                    this.$router.push('/SingleInquiry');
                });
            })
            .catch(() => {});
    }
    loadingEffect = [];
    public winTip: any = '';
    public winRemark: any = '';

    public timesIndex: any = '';
    public tag = false;
    public carrierId: any = '';
    public bidding(row, tag) {
        this.tag = tag;
        this.timesIndex = row.timesIndex;
        this.carrierId = row.quotes[0].carrierId;
        console.log('row' + JSON.stringify(row));
        if (tag) {
            let str = '';
            row.quotes.forEach((item) => {
                if (item.price) {
                    str += item.carLength + '中标价:' + item.price + ' , ';
                }
            });
            // str = str.substring(0, str.lastIndexOf(','));
            this.winTip = str + '   确认' + row.carrierName + '中标?';
        } else {
            this.winTip = '确认取消' + row.carrierName + '中标?';
        }

        this.winRemark = '';
        this.winVisible = true;
    }

    /**新增询价单 */
    public async addInquiry() {
        this.$refs.fData.validate(async (valid) => {
            if (valid) {
                this.fData.id = this.$route.query.id
                this.btt = 4;
                this.dialogConfig = {
                    title: '下发车队',
                    show: true,
                };
            }
        });
    }

    editInquiry() {
        this.$router.push({
            path: '/addOrder',
            query: {
                id: this.id,
                type: 'edit',
            },
        });
    }
    public dialogBtn: string = '';
    public isPassAudit :any = true
    accept() {
        this.$refs.formData.validate(async (valid) => {
            if (valid)  {
                this.btt = 1;
                this.dialogConfig = {
                    title: '发货计划报价',
                    show: true,
                };
            }
        })
    }
    /**终结询价单 */
    endInquiry() {
        this.ssid = '';
        this.btt = 1;
        this.dialogConfig = {
            title: '终结该发货计划',
            show: true,
        };
        // this.$confirm('确认终结该发货计划？', '发货计划终结', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         yun.IupdateOrderStatus({ id: this.$route.query.id, status: 4 }).then(() => {
        //             this.$message.success('发货计划终结成功');
        //             this.$router.push('/ordermanager');
        //         });
        //     })
        //     .catch(() => {});
    }
    /**删除询价单 */
    /**删除询价单 */
    public dialogConfig: any = {
        title: '终结该运单',
        show: false,
    };
    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }
    async confirmOk() {
        this.dialogConfig = {
            show: false,
        };
        if (this.btt == 3) {
            yun.deleteOrder(this.$route.query.id).then(() => {
                this.$message.success('发货计划删除成功');
                this.$router.push('/orderManager');
            });
        } else if (this.btt == 1) {
            this.formData.id = this.$route.query.id
            yun.updateOrderFreight(this.formData).then(() => {
                this.$message.success('报价通过成功');
                this.$router.push('/orderPayManager');
            });
        } else if (this.btt == 4) {
            yun.updateOrderAuditStatus({ id: this.$route.query.id,auditComment: this.auditComment, isPassAudit: this.isPassAudit }).then(() => {
                this.$message.success('审核退回成功');
                this.$router.push('/orderPayManager');
            });
        }
    }
    public btt: any = 0;
    public ssid: any = '';
    deleteInquiry() {
        this.ssid = '';
        this.btt = 3;
        this.dialogConfig = {
            title: '删除该发货计划',
            show: true,
        };
        // this.$confirm('确认删除该发货计划?', '发货计划删除', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         yun.deleteOrder(this.$route.query.id).then(() => {
        //             this.$message.success('发货计划删除成功');
        //             this.$router.push('/ordermanager');
        //         });
        //     })
        //     .catch(() => {});
    }

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0) {
            const _row = this.spanArr[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
                rowspan: _row,
                colspan: _col,
            };
        }
    }
    public currentBtn: any = [];

    public editForm: any = {};
    public fileList: any = [];
    public goodsForm: any = {};

    cspdiaClose() {}

    back() {
        //this.$router.push('/ordermanager');
        if (this.from) {
            this.$router.push(`/${this.from}`);
        } else if (this.fee) {
            switch (this.fee) {
                case '2':
                    this.$router.push('/costDetail');
                    break;
                case '3':
                    // this.$router.go(-1);
                    this.$router.push({
                        path: '/statementDetails',
                        query: {
                            id: this.$route.query.feeId,
                        },
                    });
                    break;

                default:
                    break;
            }
        } else {
            this.$router.push('/orderPayManager');
        }
    }

    viewFile(item) {
        if (publicFunc.getExtension2(item.name)) {
            window.open(`https://view.officeapps.live.com/op/view.aspx?src=${item.path}`);
        } else {
            window.open(item.path);
        }
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    public processStatus: boolean = false;
    public processList = [];
    public takeTime = null;
    public firData = null;
    public SecData = null;
    public d: number = 0;
    public h: number = 0;
    public m: any = 0;
    public s: any = 0;
    public time: string = '';
    public timer: any = null;

    async getprocess(e) {
        e.stopPropagation();
        this.processStatus = !this.processStatus;
        if (this.processStatus) {
            this.processList = [];
            let res = await Inquiry.GetTracks(this.id);
            this.processList = res.tracks;
            this.takeTime = this.processList[0].time;
            this.firData = this.processList[0].time;
            this.SecData = this.processList[this.processList.length - 1].time;
            if (res.isEnd) {
                this.countTime();
            } else {
                this.countTime();
            }

            console.log('this.processList' + JSON.stringify(this.processList));
        }
    }

    countTime() {
        //获取当前时间
        var date = new Date();
        var now = date.getTime();
        //设置截止时间
        var endDate = new Date(Date.parse(this.takeTime.replace(/-/g, '/')));
        var end = endDate.getTime();
        //时间差
        var leftTime = now - end;
        //定义变量 d,h,m,s保存倒计时的时间

        this.d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        this.h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.m = Math.floor((leftTime / 1000 / 60) % 60);
        this.s = Math.floor((leftTime / 1000) % 60);
        this.time = '耗时' + this.d + '天' + this.h + '小时' + this.m + '分' + this.s + '秒';
        this.timer = setTimeout(this.countTime, 1000);
    }

    countTime2() {
        var nowData = new Date(Date.parse(this.firData.replace(/-/g, '/')));
        var now = nowData.getTime();
        var endDate = new Date(Date.parse(this.SecData.replace(/-/g, '/')));
        var end = endDate.getTime();
        var leftTime = now - end;
        //定义变量 d,h,m,s保存倒计时的时间
        console.log('leftTime' + leftTime);

        this.d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        this.h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.m = Math.floor((leftTime / 1000 / 60) % 60);
        this.s = Math.floor((leftTime / 1000) % 60);
        this.time = '耗时' + this.d + '天' + this.h + '小时' + this.m + '分' + this.s + '秒';
    }
    @Watch('processStatus')
    processStatusChange() {
        if (this.processStatus == false) {
            if (this.timer) {
                clearTimeout(this.timer);
            }
        }
    }

    public carrierList = [];
    getCarrierList() {
        // CspInquiry.getLoadType({ typeName: '装车要求' }).then((res) => {
        //     this.carrierList = res.map((v) => {
        //         return v.stringData;
        //     });
        // });
    }
    downLoad(path) {
        window.open(path);
    }
}
